import React from 'react';
import { flexRender } from '@tanstack/react-table';
import Loader from '../layout/Loader';

const SortHeader = ({ header }) => (
  <>
    {flexRender(header.column.columnDef.header, header.getContext())}
    <span>
      {header.column.getIsSorted()
        ? header.column.getIsSortedDesc()
          ? ' 🔽'
          : ' 🔼'
        : ''}
    </span>
  </>
);

const stickyActionsHeaderClass =
  'sticky -right-[1px] bg-gray-50 sm:min-w-36 z-[1]';
const stickyActionsCellClass = 'sticky -right-[1px] bg-gray-50 z-[1]';

const DataTable = ({
  table,
  columnsCount,
  isLoading = false,
  emptyMessage = 'No items found',
  enableSortingIndicator = true,
  stickyActions = false,
  variant = 'default',
  getRowClassName,
  getHeaderClassName,
  emptyClassName,
  loaderClassName,
}) => {
  const isReports = variant === 'reports';
  const rows = table.getRowModel().rows;
  const isEmpty = rows.length === 0;

  const containerClassName = isReports
    ? `overflow-x-auto isolate relative border border-gray-300 rounded-[3px] ${isLoading ? 'h-[65vh]' : ''} ${
        !isLoading && isEmpty ? 'h-[50vh]' : ''
      }`
    : 'overflow-x-auto isolate shadow-md rounded-lg relative';

  const resolvedLoaderClassName =
    loaderClassName ||
    (isReports
      ? 'absolute top-[58%] left-1/2 transform -translate-x-1/2 -translate-y-1/2'
      : 'flex justify-center items-center h-[60vh]');

  const resolvedEmptyClassName =
    emptyClassName ||
    (isReports
      ? 'absolute top-[58%] left-1/2 transform -translate-x-1/2 -translate-y-1/2'
      : 'flex justify-center items-center h-[40vh]');

  return (
    <div className={containerClassName}>
      <table className="min-w-full bg-white border border-gray-300">
        <thead className="bg-gray-50">
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  className={`py-3 px-4 border-b border-gray-200 text-center text-sm font-semibold text-gray-700 ${
                    stickyActions && header.column.id === 'actions' ? stickyActionsHeaderClass : ''
                  } ${getHeaderClassName ? getHeaderClassName(header) : ''}`}
                >
                  {enableSortingIndicator ? (
                    <SortHeader header={header} />
                  ) : (
                    flexRender(header.column.columnDef.header, header.getContext())
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={columnsCount}>
                <Loader className={resolvedLoaderClassName} />
              </td>
            </tr>
          ) : isEmpty ? (
            <tr>
              <td colSpan={columnsCount}>
                <p className={resolvedEmptyClassName}>{emptyMessage}</p>
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr key={row.id} className={isReports ? '' : 'hover:bg-gray-50'}>
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    className={`py-3 px-4 border-b border-gray-200 text-sm text-gray-700 ${
                      stickyActions && cell.column.id === 'actions' ? stickyActionsCellClass : ''
                    } ${getRowClassName ? getRowClassName(row) : ''}`}
                  >
                    <div className="flex justify-center">
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </div>
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export { SortHeader };
export default DataTable;
